import { render, staticRenderFns } from "./onebox-allinboxsystem-new.vue?vue&type=template&id=68c328a8&scoped=true&"
import script from "./onebox-allinboxsystem-new.vue?vue&type=script&lang=js&"
export * from "./onebox-allinboxsystem-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-allinboxsystem-new.vue?vue&type=style&index=0&id=68c328a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c328a8",
  null
  
)

export default component.exports